<div class="objectivesAssignBox user-select">
    <div class="FlexRowNoWrap assignToContainer">
        <div class="boxHeader" cvLocalizedText langSection="MarketPlace_Management" langKey="Assigned_To">Assigned to:</div>
    </div>
    <overlay-scrollbars class="objectivesBoxScroll">
        <div>
            <div class="typeHeader" style="margin-top:8px;" cvLocalizedText langSection="MarketPlace_Management" langKey="Employee_Groups">Employee Group(s)</div>
            <!-- <div class="objectiveHeaderItem" *ngIf="showall == true && empSelected() == false">All Emp Groups</div>
            <div class="warningItem" *ngIf="showall == false && empSelected() == false">*Select at least one group</div> -->
            <div *ngFor="let obj of lst; trackBy: trackByFunction">
                <div class="FlexRowNoWrap itemContainer"
                    *ngIf="obj.BaseGroupType == 0 && !(obj.GroupLevel == 5 && obj.GroupID == 0)">
                    <div class="objectiveItem txtOverflow">- {{obj.GroupName}}</div>
                    <div cvLocalizedText langSection="MarketPlace_Management" langKey="Groups_Product" class="countItem FlexAlignVertical" *ngIf="showall == true && obj.GroupLevel > 1">{{'(' +
                        (obj.totalGroupCount ?? '') + ' Groups)'}}</div>
                    <div class="removeHolder FlexRowNoWrap">
                        <div class="removeIcon FlexAlignVertical" (click)="onRemove(obj)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="typeHeader"><span cvLocalizedText langSection="Objectives" langKey="Attributes">Attribute(s) </span><span cvLocalizedText langSection="Objectives" langKey="Optional" style="color: #6A7480;">(Optional)</span></div>
            <div *ngFor="let obj of lst | groupBy:'AgentAttributeID' | uniqueMapValues:'AttributeValueName'; trackBy: trackByFunction"
                [hidden]="!(obj.key != null)">
                <div *ngFor="let attr of attributes | filter:[{AgentAttributeID : obj.key }]" class="lato-bold">
                    {{attr.AttributeName }}
                </div>
                <div class="FlexRowNoWrap itemContainer" *ngFor="let attrValue of obj.value;"
                    [hidden]="!(attrValue.AttributeValueName != null)">
                    <div class="objectiveItem txtOverflow">- {{attrValue.AttributeValueName}}</div>
                    <div class="removeHolder FlexRowNoWrap">
                        <div class="removeIcon FlexAlignVertical" (click)="onRemove(attrValue)"></div>
                    </div>
                </div>
            </div>
        </div>
    </overlay-scrollbars>
</div>